/**
 * Component Registry for Verso
 * 
 * Inherits from @vibesites-rebel-residential/theme-verso and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-rebel-residential/theme-verso/registry';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { TabbedCallouts } from './components/TabbedCallouts';
import { AmenitiesList } from './components/AmenitiesList';
import { ManualFloorplans } from './components/ManualFloorplans';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  Header,
  Footer,
  TabbedCallouts,
  AmenitiesList,
  ManualFloorplans,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
